import Event from '../event';
import indexEvents from 'actions/event/index';
import indexConflicts from 'actions/conflict/index';

/**
 * Create the action
 */

const { thunk, request, success, error } = Event.update((data, fetch, dispatch) => {
    return fetch.post(`/event/${data.id}`, data).then((response) => {
            dispatch(indexEvents({}));
            dispatch(indexConflicts());
            return response;
        });
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
